import { HttpErrorResponse } from "@angular/common/http";
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import { Step } from "src/app/interfaces";
import { StepActions, StepAPIActions } from "./actions";

export interface StepState extends EntityState<Step> {
  error: HttpErrorResponse | null;
  loaded: boolean;
}

export const adapter: EntityAdapter<Step> = createEntityAdapter<Step>();

const {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
  /* eslint-enable @typescript-eslint/no-unused-vars */
} = adapter.getSelectors();

export const selectStepEntities = selectEntities;
export const selectAllSteps = selectAll;

const initialState: StepState = adapter.getInitialState({
  // additional entity state properties
  error: null,
  loaded: false
});

export const stepReducer = createReducer(
  initialState,
  on(StepActions.addStep, (state, action) =>
    adapter.addOne(action.step, state)
  ),
  on(StepActions.upsertStep, (state, action) =>
    adapter.upsertOne(action.step, state)
  ),
  on(StepActions.addSteps, (state, action) =>
    adapter.addMany(action.steps, state)
  ),
  on(
    StepActions.upsertSteps,
    StepAPIActions.loadStepsForCirculationSuccess,
    (state, action) => adapter.upsertMany(action.steps, state)
  ),
  on(StepActions.updateStep, (state, action) =>
    adapter.updateOne(action.step, state)
  ),
  on(StepActions.updateSteps, (state, action) =>
    adapter.updateMany(action.steps, state)
  ),
  on(StepActions.deleteStep, (state, action) =>
    adapter.removeOne(action.id as number, state)
  ),
  on(StepActions.deleteSteps, (state, action) =>
    adapter.removeMany(action.ids as number[], state)
  ),
  on(StepActions.clearSteps, (state) => adapter.removeAll(state)),
  on(
    StepAPIActions.loadStepsForCirculationFailure,
    (state, action): StepState => {
      return {
        ...adapter.removeAll(state),
        error: action.error,
        loaded: false
      };
    }
  )
);
